// Application configuration
export const config = {
  // API Configuration - Smart fallback based on environment
  apiUrl: process.env.REACT_APP_API_URL ||
    (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      ? 'http://localhost:8025/api'
      : 'https://asknow.meander.one/api'),

  // Backend Server URL (used for proxy in development)
  backendUrl: process.env.REACT_APP_BACKEND_URL ||
    (typeof window !== 'undefined' && (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1')
      ? 'http://localhost:8025'
      : 'https://asknow.meander.one'),

  // Validation rules
  validation: {
    username: {
      minLength: 3,
      maxLength: 50,
    },
    password: {
      minLength: 8,
    },
    entityName: {
      minLength: 1,
      maxLength: 255,
    },
    entityDescription: {
      maxLength: 1000,
    },
    chatMessage: {
      minLength: 1,
      maxLength: 2000,
    },
  },
};
